import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Chip } from '../Chip';
import { Input } from '../Input';
// Free values typed or pasted one by one or as a comma list (tags, ids, postal
// codes). Enter, a comma or leaving the input adds them; Backspace on an empty
// input removes the last one.
export const TagInput = ({ values, onChange, placeholder, emptyText, readOnly, autoFocus, removeLabel }) => {
    const [draft, setDraft] = useState('');
    const commit = () => {
        const added = [
            ...new Set(draft.split(',').map((v) => v.trim()))
        ].filter((value) => value && !values.includes(value));
        if (added.length)
            onChange([...values, ...added]);
        setDraft('');
    };
    // A read-only field has no input to hold the placeholder, so it stands in for the empty copy.
    const emptyCopy = readOnly ? (emptyText ?? placeholder) : emptyText;
    return (_jsxs("div", { className: "flex flex-col gap-2", children: [readOnly ? null : (_jsx(Input, { autoFocus: autoFocus, value: draft, placeholder: placeholder, onChange: (event) => setDraft(event.target.value), onBlur: commit, onKeyDown: (event) => {
                    if (event.key === 'Enter' || event.key === ',') {
                        event.preventDefault();
                        commit();
                    }
                    else if (event.key === 'Backspace' &&
                        !draft &&
                        values.length) {
                        onChange(values.slice(0, -1));
                    }
                } })), values.length ? (_jsx("ul", { className: "m-0 flex list-none flex-wrap gap-2 p-0", children: values.map((value) => (_jsx("li", { children: _jsx(Chip, { onRemove: readOnly
                            ? undefined
                            : () => onChange(values.filter((v) => v !== value)), removeLabel: removeLabel(value), children: value }) }, value))) })) : emptyCopy ? (_jsx("p", { className: "font-roobert text-xs text-neutral-500", children: emptyCopy })) : null] }));
};
